var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenSource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18997_321",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18997_321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 40H36V20H12V40ZM24 34C25.1 34 26.0417 33.6083 26.825 32.825C27.6083 32.0417 28 31.1 28 30C28 28.9 27.6083 27.9583 26.825 27.175C26.0417 26.3917 25.1 26 24 26C22.9 26 21.9583 26.3917 21.175 27.175C20.3917 27.9583 20 28.9 20 30C20 31.1 20.3917 32.0417 21.175 32.825C21.9583 33.6083 22.9 34 24 34ZM12 44C10.9 44 9.95833 43.6083 9.175 42.825C8.39167 42.0417 8 41.1 8 40V20C8 18.9 8.39167 17.9583 9.175 17.175C9.95833 16.3917 10.9 16 12 16H26V12C26 9.23333 26.975 6.875 28.925 4.925C30.875 2.975 33.2333 2 36 2C38.7667 2 41.125 2.975 43.075 4.925C45.025 6.875 46 9.23333 46 12H42C42 10.3333 41.4167 8.91667 40.25 7.75C39.0833 6.58333 37.6667 6 36 6C34.3333 6 32.9167 6.58333 31.75 7.75C30.5833 8.91667 30 10.3333 30 12V16H36C37.1 16 38.0417 16.3917 38.825 17.175C39.6083 17.9583 40 18.9 40 20V40C40 41.1 39.6083 42.0417 38.825 42.825C38.0417 43.6083 37.1 44 36 44H12Z",
    fill: "#F1F7F7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSource);
export default __webpack_public_path__ + "static/media/open-source.cdb1892b335cf4ff5f557130a089c03e.svg";
export { ForwardRef as ReactComponent };